import {modals} from "@mantine/modals";
import ReleaseNotesModal from "@/components/ReleaseNotesModal/modal.tsx";
import OmniFetchTS from "@/util/OmniFetchTS.tsx";
import {IUser} from "@/types/models/IUser.ts";
import gt from "semver/functions/gt";
export const RELEASE_NOTES_MODAL_ID = "releaseNotesModal"

export enum ReleaseNotesVersion {
    _0_29_0 = "0.29.0",
    _0_29_1 = "0.29.1",
    _0_30_0 = "0.30.0",
    _0_31_0 = "0.31.0",
    _0_32_0 = "0.32.0",
    _0_36_0 = "0.36.0",
}

export const RELEASE_NOTES_VERSIONS = Object.values(ReleaseNotesVersion)

export function shouldOpenReleaseNotesModalOnLoad(user: IUser): boolean {
    const lastViewedVersion = user.last_viewed_version_notes
    return lastViewedVersion != undefined && RELEASE_NOTES_VERSIONS.some((v) => {
        return gt(v, lastViewedVersion)
    })

}

export default function openReleaseNotesModal(showAll?: boolean) {
    modals.open({
        modalId: RELEASE_NOTES_MODAL_ID,
        size: "xxl",
        title: "Release Notes",
        children: <ReleaseNotesModal showAll={showAll}/>,
        onClose: () => {
            if (!showAll) OmniFetchTS("/api/v1/users/me/read_release_notes", {method: "POST"}).then()
        }
    })
}